import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

interface PharmacyDetailsItemProps {
  label: string;
  value: string;
}

const PharmacyDetailsItem:React.FunctionComponent<PharmacyDetailsItemProps> = ({
  label,
  value,
}) => (
  <Grid sx={{display: 'flex'}} item xs={12} sm={12} md={12} lg={4}>
    <Box>{label}</Box>
    <Box sx={{ ml: 1, fontWeight: 'bold' }}>{value}</Box>
  </Grid>
);

export default PharmacyDetailsItem;